import React, { useState } from 'react';
import axios from 'axios';

const ImageUpload = ({ onUpload }) => {
    const [file, setFile] = useState(null);

    const handleSubmit = async e => {
        e.preventDefault();
        if (!file) return;

        const formData = new FormData();
        formData.append('image', file);
        await axios.post('https://travelback-thuw.onrender.com/api/auth/upload-image', formData);
        alert('Image uploaded successfully!');
        setFile(null);
        onUpload();
    };

    return (
        <form onSubmit={handleSubmit}>
            <input type="file" accept="image/*" onChange={e => setFile(e.target.files[0])} />
            <button type="submit">Upload</button>
        </form>
    );
}

export default ImageUpload;




